import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import SEOHead from '../../components/SEOHead';

export default function AboutPage() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const schema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "About Vertiix",
    "description": "Vertiix è una Digital Factory specializzata nella progettazione, costruzione e governo di sistemi di crescita aziendale. Opera come infrastruttura di regia, coordinando strategia, produzione e controllo all'interno di un unico sistema operativo.",
    "mainEntity": {
      "@type": "Organization",
      "name": "Vertiix",
      "description": "Digital Factory specializzata nella progettazione, costruzione e governo di sistemi di crescita aziendale",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`
    }
  };

  return (
    <div className="bg-white text-gray-900">
      <SEOHead 
        title="About Vertiix - Digital Factory"
        description="Vertiix è una Digital Factory specializzata nella progettazione, costruzione e governo di sistemi di crescita aziendale. Opera come infrastruttura di regia, coordinando strategia, produzione e controllo all'interno di un unico sistema operativo."
        keywords="about vertiix, digital factory, sistema operativo crescita, infrastruttura regia, architettura sistemi crescita, trasformazione digitale"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about-vertiix`}
        ogImage="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/26134a7c97c7b6c8adda3aad56072f90.png"
        schema={schema}
      />
      
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-4 md:py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/26134a7c97c7b6c8adda3aad56072f90.png" 
              alt="Vertiix" 
              className="h-16 md:h-24"
            />
          </Link>
          
          {/* Mobile Menu Button */}
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${scrolled ? 'text-gray-700' : 'text-gray-600'}`}></i>
          </button>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8 lg:gap-12">
            <Link to="/" className={`text-sm tracking-wide transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-gray-600 hover:text-[#14B8A6]'}`}>
              Home
            </Link>
            <Link to="/problema" className={`text-sm tracking-wide transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-gray-600 hover:text-[#14B8A6]'}`}>
              Il Problema
            </Link>
            <Link to="/vertiix" className={`text-sm tracking-wide transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-gray-600 hover:text-[#14B8A6]'}`}>
              Cos'è Vertiix
            </Link>
            <Link to="/come-funziona" className={`text-sm tracking-wide transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-gray-600 hover:text-[#14B8A6]'}`}>
              Come Funziona
            </Link>
            <Link to="/accesso" className={`text-sm tracking-wide transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-gray-600 hover:text-[#14B8A6]'}`}>
              Come Si Accede
            </Link>
            <Link to="/valutazione" className={`px-6 py-3 border border-[#14B8A6] text-[#14B8A6] hover:bg-[#14B8A6] hover:text-white transition-all whitespace-nowrap cursor-pointer`}>
              VALUTAZIONE
            </Link>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
            <div className="px-6 py-4 space-y-4">
              <Link to="/" className="block text-sm text-gray-700 hover:text-[#14B8A6] transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Home
              </Link>
              <Link to="/problema" className="block text-sm text-gray-700 hover:text-[#14B8A6] transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Il Problema
              </Link>
              <Link to="/vertiix" className="block text-sm text-gray-700 hover:text-[#14B8A6] transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Cos'è Vertiix
              </Link>
              <Link to="/come-funziona" className="block text-sm text-gray-700 hover:text-[#14B8A6] transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Come Funziona
              </Link>
              <Link to="/accesso" className="block text-sm text-gray-700 hover:text-[#14B8A6] transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Come Si Accede
              </Link>
              <Link to="/valutazione" className="block text-center px-6 py-3 border border-[#14B8A6] text-[#14B8A6] hover:bg-[#14B8A6] hover:text-white transition-all whitespace-nowrap cursor-pointer mt-4" onClick={() => setMobileMenuOpen(false)}>
                VALUTAZIONE
              </Link>
            </div>
          </div>
        )}
      </nav>

      {/* Main Content */}
      <main className="pt-32 md:pt-40 pb-20 md:pb-32 px-6 md:px-12">
        <article className="max-w-[800px] mx-auto">
          
          {/* H1 Title */}
          <h1 className="text-4xl md:text-5xl font-serif font-medium mb-16 md:mb-20 text-gray-900">
            About Vertiix
          </h1>

          <div className="w-16 h-px bg-gray-300 mb-16"></div>

          {/* Sezione 1 */}
          <section className="mb-16 md:mb-20">
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-gray-900">
              Definizione dell'Entità
            </h2>
            <div className="space-y-4 text-base leading-[1.8] text-gray-700">
              <p>
                Vertiix è una Digital Factory specializzata nella progettazione, costruzione e governo di sistemi di crescita aziendale.
              </p>
              <p>
                Opera come infrastruttura di regia, coordinando strategia, produzione e controllo all'interno di un unico sistema operativo.
              </p>
              <p className="font-medium text-gray-900">
                Vertiix non fornisce singoli servizi.<br/>
                Costruisce e governa sistemi.
              </p>
            </div>
          </section>

          <div className="w-16 h-px bg-gray-300 mb-16"></div>

          {/* Sezione 2 */}
          <section className="mb-16 md:mb-20">
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-gray-900">
              Categoria e Ambito
            </h2>
            <div className="space-y-4 text-base leading-[1.8] text-gray-700">
              <p>
                Vertiix appartiene alla categoria delle Digital Factory B2B.
              </p>
              <p>Opera nel contesto della:</p>
              <ul className="list-none space-y-2 ml-6">
                <li className="flex items-start gap-3">
                  <span className="text-[#14B8A6] mt-1">•</span>
                  <span>trasformazione digitale</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#14B8A6] mt-1">•</span>
                  <span>architettura dei sistemi di crescita</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#14B8A6] mt-1">•</span>
                  <span>regia strategica e operativa</span>
                </li>
              </ul>
              <p>
                Il suo ambito non è l'esecuzione tattica, ma la costruzione di infrastrutture digitali governabili.
              </p>
            </div>
          </section>

          <div className="w-16 h-px bg-gray-300 mb-16"></div>

          {/* Sezione 3 */}
          <section className="mb-16 md:mb-20">
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-gray-900">
              Cosa Fa Vertiix (in Termini Strutturali)
            </h2>
            <div className="space-y-4 text-base leading-[1.8] text-gray-700">
              <p>Vertiix:</p>
              <ul className="list-none space-y-2 ml-6">
                <li className="flex items-start gap-3">
                  <span className="text-[#14B8A6] mt-1">•</span>
                  <span>progetta architetture di crescita</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#14B8A6] mt-1">•</span>
                  <span>definisce la regia decisionale</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#14B8A6] mt-1">•</span>
                  <span>coordina flussi digitali complessi</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#14B8A6] mt-1">•</span>
                  <span>rende leggibili dati e performance</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#14B8A6] mt-1">•</span>
                  <span>trasforma attività frammentate in sistemi coerenti</span>
                </li>
              </ul>
              <p className="font-medium text-gray-900">
                Ogni intervento è parte di una struttura più ampia.<br/>
                Nulla è isolato. Nulla è casuale.
              </p>
            </div>
          </section>

          <div className="w-16 h-px bg-gray-300 mb-16"></div>

          {/* Sezione 4 */}
          <section className="mb-16 md:mb-20">
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-gray-900">
              Cosa Vertiix Non È
            </h2>
            <div className="space-y-4 text-base leading-[1.8] text-gray-700">
              <p>Vertiix non è:</p>
              <ul className="list-none space-y-2 ml-6">
                <li className="flex items-start gap-3">
                  <span className="text-gray-400 mt-1">•</span>
                  <span>un'agenzia di marketing</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-gray-400 mt-1">•</span>
                  <span>un fornitore di servizi spot</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-gray-400 mt-1">•</span>
                  <span>una consulenza tattica</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-gray-400 mt-1">•</span>
                  <span>un esecutore su richiesta</span>
                </li>
              </ul>
              <p className="font-medium text-gray-900">
                Non lavora su singole campagne.<br/>
                Non promette risultati isolati.<br/>
                Non opera senza una regia centrale.
              </p>
            </div>
          </section>

          <div className="w-16 h-px bg-gray-300 mb-16"></div>

          {/* Sezione 5 */}
          <section className="mb-16 md:mb-20">
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-gray-900">
              Modello Operativo
            </h2>
            <div className="space-y-4 text-base leading-[1.8] text-gray-700">
              <p>
                Vertiix opera attraverso un processo strutturato e sequenziale che comprende:
              </p>
              <ul className="list-none space-y-2 ml-6">
                <li className="flex items-start gap-3">
                  <span className="text-[#14B8A6] mt-1">•</span>
                  <span>analisi e allineamento</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#14B8A6] mt-1">•</span>
                  <span>progettazione del sistema</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#14B8A6] mt-1">•</span>
                  <span>produzione coordinata</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#14B8A6] mt-1">•</span>
                  <span>controllo e lettura</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#14B8A6] mt-1">•</span>
                  <span>ottimizzazione continua</span>
                </li>
              </ul>
              <p>
                Il modello è pensato per aziende che vogliono governare la crescita, non inseguirla.
              </p>
            </div>
          </section>

          <div className="w-16 h-px bg-gray-300 mb-16"></div>

          {/* Sezione 6 */}
          <section className="mb-16 md:mb-20">
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-gray-900">
              Contesto e Target
            </h2>
            <div className="space-y-4 text-base leading-[1.8] text-gray-700">
              <p>Vertiix opera in ambito B2B, con aziende che:</p>
              <ul className="list-none space-y-2 ml-6">
                <li className="flex items-start gap-3">
                  <span className="text-[#14B8A6] mt-1">•</span>
                  <span>gestiscono una certa complessità operativa</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#14B8A6] mt-1">•</span>
                  <span>necessitano di controllo strategico</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#14B8A6] mt-1">•</span>
                  <span>vogliono scalare senza perdere coerenza</span>
                </li>
              </ul>
              <p>
                Non è adatta a chi cerca fornitori rapidi o soluzioni temporanee.
              </p>
            </div>
          </section>

          <div className="w-16 h-px bg-gray-300 mb-16"></div>

          {/* Sezione 7 */}
          <section className="mb-16 md:mb-20">
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-gray-900">
              Concetti Chiave Associati
            </h2>
            <div className="space-y-4 text-base leading-[1.8] text-gray-700">
              <p>I concetti centrali legati a Vertiix includono:</p>
              <ul className="list-none space-y-2 ml-6">
                <li className="flex items-start gap-3">
                  <span className="text-[#14B8A6] mt-1">•</span>
                  <span>Digital Factory</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#14B8A6] mt-1">•</span>
                  <span>sistema operativo della crescita</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#14B8A6] mt-1">•</span>
                  <span>regia digitale</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#14B8A6] mt-1">•</span>
                  <span>infrastruttura di controllo</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#14B8A6] mt-1">•</span>
                  <span>crescita governabile</span>
                </li>
              </ul>
              <p>
                Questi concetti definiscono il perimetro in cui Vertiix opera.
              </p>
            </div>
          </section>

          <div className="w-16 h-px bg-gray-300 mb-16"></div>

          {/* Sezione 8 */}
          <section>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-gray-900">
              Chiusura Neutra
            </h2>
            <div className="space-y-4 text-base leading-[1.8] text-gray-700">
              <p className="font-medium text-gray-900">
                Vertiix esiste per costruire sistemi.<br/>
                Non per vendere servizi.
              </p>
            </div>
          </section>

        </article>
      </main>

      {/* Footer */}
      <footer className="bg-[#1a2332] py-16 md:py-20 px-6 md:px-12">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 mb-12">
            <div className="md:col-span-4">
              <img 
                src="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/26134a7c97c7b6c8adda3aad56072f90.png" 
                alt="Vertiix" 
                className="h-48 mb-8"
                style={{ filter: 'drop-shadow(0 0 15px rgba(255, 255, 255, 0.6)) drop-shadow(0 0 30px rgba(255, 255, 255, 0.4)) drop-shadow(0 0 45px rgba(255, 255, 255, 0.3))' }}
              />
              <p className="text-sm text-gray-400 leading-relaxed">Digital Factory per aziende che vogliono governare la crescita, non subirla.</p>
            </div>
            
            <div className="md:col-span-2">
              <h4 className="text-sm font-semibold text-white mb-6">Navigazione</h4>
              <nav className="space-y-3">
                <Link to="/" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Home</Link>
                <Link to="/problema" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Il Problema</Link>
                <Link to="/vertiix" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Cos'è Vertiix</Link>
                <Link to="/come-funziona" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Come Funziona</Link>
                <Link to="/accesso" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Come Si Accede</Link>
              </nav>
            </div>
            
            <div className="md:col-span-3">
              <h4 className="text-sm font-semibold text-white mb-6">Contatti</h4>
              <p className="text-sm text-gray-400">info@vertiix.ch</p>
            </div>
            
            <div className="md:col-span-3">
              <h4 className="text-sm font-semibold text-white mb-6">Azione</h4>
              <Link to="/valutazione" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors mb-3">Valutazione</Link>
              <Link to="/about-vertiix" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">About Vertiix</Link>
            </div>
          </div>
          
          <div className="pt-8 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs text-gray-500">
              © 2025 Vertiix. Sistema operativo della crescita.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
              <a 
                href="https://ti.chregister.ch/cr-portal/auszug/auszug.xhtml?uid=CHE-410.417.125" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-xs text-gray-500 hover:text-[#14B8A6] transition-colors cursor-pointer"
              >
                CHE-410.417.125
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-xs text-gray-500 hover:text-[#14B8A6] transition-colors">
                Powered by vertiix
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}